import React from 'react';
import { Empty as AntEmpty } from 'antd';
import { InboxFilledIcon } from '@components/icons';

function Empty({ text, ...rest }) {
  return (
    <AntEmpty
      className="empty"
      image={<InboxFilledIcon width={60} height={60} />}
      description={text}
      {...rest}
    />
  );
}

export default Empty;
